import { PropsWithChildren } from 'react';
import { SHProvider } from '@libs/creditkit';
import { useDogxContext } from '@libs/dogx';

type SHProviderExperimentProps = PropsWithChildren<{
  baseURL?: string;
}>;

const SHProviderExperiment = ({ children, baseURL }: SHProviderExperimentProps) => {
  const dxScOffersV2 = 'dx-sc-offers-v2';
  const hasOffersEndpoint = 'has-offers-endpoint';

  const { getExperimentVariant } = useDogxContext();
  const singleCallMode = (getExperimentVariant(dxScOffersV2) ?? 'control') === hasOffersEndpoint;

  return (
    <SHProvider
      appName="cp"
      mode={import.meta.env.VITE_ENV}
      shKey={import.meta.env.VITE_SORTING_HAT_API_KEY}
      baseURL={baseURL}
      identifier="userDocument"
      singleCallMode={singleCallMode}
    >
      {children}
    </SHProvider>
  );
};

export default SHProviderExperiment;
